// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Seguridad en la Nube?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            Los Servicios de Seguridad en la Nube ofrecen un conjunto completo de soluciones y evaluaciones diseñadas para proteger tus datos, aplicaciones e infraestructura en entornos de nube. Estos servicios abarcan varios proveedores de nube, abordando factores como la protección de datos, el cumplimiento, la escalabilidad y las características específicas del proveedor para fortalecer tu postura de seguridad en la nube.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Seguridad en la Nube
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="code"
                title="Experiencia Multi-Proveedor"
                description="Nuestros servicios cubren una variedad de proveedores de nube, incluidos Azure, Google Cloud, AWS y otros, asegurando una evaluación holística de tus opciones de seguridad en la nube."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="search"
                title="Análisis en Profundidad"
                description="Realizamos análisis meticulosos para obtener una comprensión profunda de las capacidades y limitaciones de cada solución de seguridad en la nube."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="plagiarism"
                title="Evaluación Imparcial"
                description="Proporcionamos evaluaciones imparciales, guiando a las organizaciones en la selección de soluciones de seguridad en la nube alineadas con sus requisitos y objetivos de seguridad únicos."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="pentagon"
                title="Informes Exhaustivos"
                description="Las organizaciones reciben informes detallados con información, calificaciones, pros y contras, y recomendaciones personalizadas específicas para su proveedor de seguridad en la nube elegido."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="public"
                title="Pruebas en el Mundo Real"
                description="Nuestros escenarios de pruebas en el mundo real evalúan cómo las soluciones de seguridad en la nube se desempeñan en entornos prácticos de nube, proporcionando información accionable."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            Por Qué Importa la Seguridad en la Nube
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="alt_route"
                title="Toma de Decisiones Informada"
                description="Nuestros servicios permiten a las organizaciones tomar decisiones informadas al seleccionar soluciones de seguridad en la nube, asegurando la seguridad de sus activos digitales en la nube."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="lock"
                title="Protección de Datos"
                description="Las evaluaciones se centran en la seguridad de los datos, el cumplimiento y la gobernanza, mitigando los riesgos asociados con las vulnerabilidades de seguridad en la nube."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="airline_stops"
                title="Escalabilidad y Flexibilidad"
                description="Las organizaciones pueden elegir soluciones de seguridad en la nube que se escalen sin problemas con sus necesidades en evolución y se alineen con su estrategia de nube."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="api"
                title="Aprovechamiento de Características Específicas del Proveedor"
                description="La información sobre las características específicas del proveedor permite a las organizaciones aprovechar las fortalezas de diferentes soluciones de seguridad en la nube."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Papel de la Seguridad en la Nube en la Protección Digital
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            Los Servicios de Seguridad en la Nube son fundamentales en las estrategias modernas de ciberseguridad, especialmente en una era donde la adopción de la nube es ubicua. Estos servicios permiten a las organizaciones navegar el complejo panorama de la seguridad en la nube con confianza, asegurando que sus inversiones en seguridad en la nube cumplan con sus necesidades específicas, protejan sus activos digitales y fortalezcan su postura general de seguridad.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;